// eslint-disable-next-line import/no-anonymous-default-export
export default {
  SET_MODAL_WORK: 'SET_MODAL_WORK',
  SET_PAGE: 'SET_PAGE',
  CLEAR_MODAL_WORK_STATE: 'CLEAR_MODAL_WORK_STATE',
};
